import * as React from 'react';
import Navigation from '../../constants/enums/NavigationEnum'
import { Redirect, RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import validator from 'validator';
import { ApplicationState } from '../../store';
import * as AccountStore from '../../store/AccountStore';
import adPoster from '../../images/imgPhone.png'
import backIcon from '../../images/backArrowIcon.svg'
import archive from '../../images/tariffIcons/archive.png'
import count from '../../images/tariffIcons/count.png'
import key from '../../images/tariffIcons/key.png'
import fullArchive from '../../images/tariffIcons/fullArchive.png'
import lenght from '../../images/tariffIcons/lenght.png'
import quality from '../../images/tariffIcons/quality.png'
import support from '../../images/tariffIcons/support.png'
import widget from '../../images/tariffIcons/widget.png'
import CloseIcon from '../../images/dynamicIcons/closeIcon';
import checkMarkIcon from '../../images/checkMarkIcon.svg'
import DataString from '../components/DataString';
import Input from '../components/Input';
import PeriodMarkIcon from '../../images/dynamicIcons/periodMarkIcon';
import OfferMarkIcon from '../../images/dynamicIcons/offerMarkIcon';
import { Popup } from '../components/Modals';
import { orderBy } from 'lodash';
import { Spinner } from '../components/Loader';
import { CreateTaskTagMobileServiceRequest, MobileService, MobileServiceCardVm } from '../../models/ServiceModels';
import { ServicesRequests } from '../../apiRequests/ServicesRequests';
import { ToastNotificationManager } from '../../infrastructure/ToastNotificationManager';
import { NotificationTypeEnum } from '../../models/NotificationModels';
import moment from 'moment';

type SubscriptionPageProps =
    AccountStore.AccountStateState &
    typeof AccountStore.actionCreators &
    RouteComponentProps<{}>;

interface SubscriptionPageState {
    nextIsOpen: boolean,
    selectedPeriod: number,
    offerAdopted: boolean,
    popupIsOpen: boolean,
    activationProcessed: boolean,
    subscribeSuccessIsOpen: boolean,
    subscribeErrorIsOpen: boolean,
    subscriptionRenewal: boolean,
    emailNotification: string | null,
    isValidEmailNotification: boolean,

}




class SubscriptionPage extends React.PureComponent<SubscriptionPageProps, SubscriptionPageState> {

    constructor(props: SubscriptionPageProps) {
        super(props);

        this.state = {
            nextIsOpen: false,
            selectedPeriod: 0,
            offerAdopted: false,
            popupIsOpen: false,
            activationProcessed: false,
            subscribeSuccessIsOpen: false,
            subscribeErrorIsOpen: false,
            subscriptionRenewal: true,
            emailNotification: null,
            isValidEmailNotification: false,
        }
    }

    apiServicesRequests = new ServicesRequests();

    private GetAmount(amount: number, discount: number, count: number): number {
        let basicAmount = amount;
        let amountFinal = (basicAmount - (basicAmount * (discount / 100)));
        return Math.floor((amountFinal * count) * 100) / 100;
    }

    private GetFullAmount(amount: number, count: number): number {
        return Math.floor((amount * count) * 100) / 100;
    }

    private GetMouth(countMouth: number) {
        if (countMouth === 1) {
            return "месяц"
        }
        else if (countMouth >= 2 && countMouth <= 4) {
            return "месяца"

        }
        else if (countMouth >= 5 && countMouth <= 12) {
            return "месяцев"

        }
        else {
            return "месяц"

        }
    }





    private async ActivateService_onClick(command: CreateTaskTagMobileServiceRequest) {
        if (!this.state.activationProcessed) {
            this.setState({ activationProcessed: true });

            let response = await this.apiServicesRequests.ActivationMobileService(command);
            if (response.result) {
                await this.props.GetMobileServiceCurrentStatusAction(this.props.selectedAccount);
                this.setState({ activationProcessed: false, subscribeSuccessIsOpen: true });

            }
            else
                this.setState({ activationProcessed: false, subscribeErrorIsOpen: true });
        }
    }




    public render() {
        let service = this.props.accounts[this.props.selectedAccount].availableServices[0] as any as MobileService

        let cards = orderBy([...(service?.discounts || []).map(x => {
            let result: MobileServiceCardVm = {
                serviceId: service.serviceId,
                serviceName: service.serviceName,
                serviceFullName: service.serviceFullName,
                tarif: this.GetAmount(service.fullTarif, x.discount, x.monthCount),
                isDiscount: true,
                fullTarif: this.GetFullAmount(service.fullTarif, x.monthCount),
                discount: x.discount,
                discountCategory: x.discountCategory,
                requirements: x.requirements,
                monthCount: x.monthCount

            };
            return result;
        }), {
            serviceId: service.serviceId,
            serviceName: service.serviceName,
            serviceFullName: service.serviceFullName,
            tarif: service.tarif,
            isDiscount: service.isDiscount,
            fullTarif: service.fullTarif,
            discount: service.discount,
            discountCategory: service.discountCategory,
            requirements: service.requirements,
            monthCount: 1
        }], x => x.monthCount)



        let selectedCard = cards[this.state.selectedPeriod];
        let yearDiscount = cards.find(x => x.monthCount === 12);

        return (
            <> {service !== undefined && selectedCard !== undefined ?
                <>
                    <Popup isOpen={this.state.popupIsOpen} onClose={() => !this.state.activationProcessed && this.setState({ popupIsOpen: false })}>
                        <div className='sub__period_periods_offer_popup'>
                            <div className='text-bold '>Вы подключаете «Видеосервисы» на {selectedCard.monthCount} мес. за {selectedCard.tarif} <span style={{ fontFamily: "Roboto" }}>₽</span></div>
                            <div className='name-passive--8'>{
                                this.state.subscriptionRenewal ?
                                    <>Подписка будет продлена автоматически<br />
                                        Следующее списание {moment().add(selectedCard.monthCount, 'M').format("DD.MM.yyyy")}
                                        <br />
                                        <br />
                                        <div className={`name-passive--8 ${!this.state.isValidEmailNotification && "validation-error-text--red"}`}>Укажите почту для получения уведомлений о списаниях</div>
                                        <div>
                                            <Input type="string" onChange={(value) => {
                                                let email = value?.trim();
                                                this.setState({
                                                    isValidEmailNotification: validator.isEmail(email),
                                                    emailNotification: email
                                                });
                                            }} placeholder='' />
                                        </div>
                                        <br />
                                        Оплата подписки станет доступна через некоторое время
                                    </>
                                    : "Оплата подписки станет доступна через некоторое время"
                            }</div>
                            <div className={`sub__period_periods_offer_popup_button button button-text ${(this.state.subscriptionRenewal && !this.state.isValidEmailNotification) && "disabled"}`}

                                onClick={() => {
                                    if (this.state.isValidEmailNotification || !this.state.subscriptionRenewal) {

                                        this.ActivateService_onClick({
                                            personalAccountId: this.props.accounts[this.props.selectedAccount].balance.personalAccountId,
                                            serviceId: service?.serviceId,
                                            serviceName: service?.serviceName,
                                            serviceFullName: service?.serviceFullName,
                                            tarif: service.fullTarif,
                                            discount: selectedCard.discount || 0,
                                            monthCount: selectedCard.monthCount,
                                            isSubscription: this.state.subscriptionRenewal,
                                            emailNotification: this.state.emailNotification,
                                            offerAdopted: this.state.offerAdopted,                                        })
                                    }
                                }}>
                                {this.state.activationProcessed ? <Spinner color={"blue"} /> : "Подтвердить"}
                            </div>
                            <div className='sub__period_periods_offer_popup_close button'
                                onClick={() => !this.state.activationProcessed && this.setState({ popupIsOpen: false })}><CloseIcon /></div>
                        </div>
                    </Popup>
                    <Popup isOpen={this.state.subscribeSuccessIsOpen} onClose={() => this.setState({ subscribeSuccessIsOpen: false, popupIsOpen: false })}>
                        <div className='info-popup'>
                            <div className='info-popup_wrapper'>
                                <div className='text-bold'>Заявка на подключение тарифа создана!</div>
                                <div className='name-passive--8'>Отслеживайте статус заявки для оплаты тарифа на главной странице.</div>
                            </div>
                            <div className='info-popup_button button button-text'
                                onClick={() => { this.props.history.push(Navigation.GeneralPage) }}>Закрыть</div>
                        </div>
                    </Popup>
                    <Popup isOpen={this.state.subscribeErrorIsOpen} onClose={() => this.setState({ subscribeErrorIsOpen: false, popupIsOpen: false })}>
                        <div className='info-popup'>
                            <div className='info-popup_wrapper'>
                                <div className='text-bold'>Что-то пошло не так!</div>
                                <div className='name-passive--8'>Не удалось подключить услугу, попробуйте позднее</div>
                            </div>
                            <div className='info-popup_button red button button-text'
                                onClick={() => { this.props.history.push(Navigation.GeneralPage) }}>Закрыть</div>
                        </div>
                    </Popup>
                    {this.state.nextIsOpen
                        ?
                        <div className='sub'>
                            <div className='sub__pediod'>
                                <div className='sub__period_close-button button' onClick={() => this.props.history.push(Navigation.GeneralPage)}><CloseIcon /></div>
                                <div className='sub__period_title period-title'>Выберите срок подписки и перейдите к оплате</div>

                                <div className='sub__period_periods'>
                                    {cards.map((e, index) =>
                                        <div className={`sub__period_periods_item ${this.state.selectedPeriod === index && "selected"}`} key={index}
                                            onClick={() => this.setState({ selectedPeriod: index })}>
                                            <div className='sub__period_periods_item_marker'><PeriodMarkIcon /></div>
                                            <div className='sub__period_periods_item_details'>
                                                <div className='text-bold'>
                                                    <span style={{
                                                        color: "rgba(44, 59, 72, 0.8)"
                                                    }}>{e.monthCount} {this.GetMouth(e.monthCount)}
                                                    </span>
                                                    {e.isDiscount &&
                                                        <span style={{
                                                            borderRadius:"20px",
                                                            backgroundColor:"rgba(255, 44, 47, 0.16)",
                                                            padding:"2px 6px 2px 6px",
                                                            marginLeft:"10px",
                                                            fontSize:"14px",

                                                            color:"rgba(255, 44, 47, 1)",
                                                            textDecoration:"none",
                                                            fontWeight:"normal"
                                                        }}>
                                                            скидка {e.discount||0}%
                                                        </span>
                                                    }

                                                </div>
                                                <div className='name-passive--10'>
                                                    <span style={{
                                                        color:"black",
                                                        fontSize:"22px",
                                                        fontWeight:"500"

                                                    }}>
                                                        {e.tarif} ₽
                                                    </span>
                                                    {e.isDiscount &&
                                                        <span style={{
                                                            marginLeft:"10px",
                                                            fontSize:"16px",
                                                            fontWeight:"400",
                                                            color:"rgba(44, 59, 72, 0.8)",
                                                            textDecoration:"line-through",
                                                            textDecorationColor:"red"
                                                        }}>
                                                            {e.fullTarif} ₽
                                                        </span>

                                                    }
                                                    
                                                </div>
                                            </div>
                                            <div className='sub__period_periods_item_explanation name-passive--10'></div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div
                                className={`sub__period_periods_button button button-text ${!this.state.offerAdopted && "disabled"}`}
                                onClick={() => this.state.offerAdopted && this.setState({ popupIsOpen: true })}>
                                Продолжить</div>
                            <div className='sub__period_periods_offer_wrapper'>
                                <div className='sub__period_periods_offer'>
                                    <div className={`sub__period_periods_offer_check-mark ${this.state.offerAdopted && "adopted"}`}
                                        onClick={() => this.setState({ offerAdopted: !this.state.offerAdopted })}><OfferMarkIcon /></div>
                                    <div className='text-mini'>подтверждаю свое согласие на подключение услуги <a href='https://cyfral-group.ru/offer'>«Платные мобильные видеосервисы»</a> от ООО «Цифрал-Сервис»</div>
                                </div>
                                {/*
                                <div className='sub__period_periods_offer'>
                                    <div className={`sub__period_periods_offer_check-mark ${this.state.subscriptionRenewal && "adopted"}`}
                                        onClick={() => this.setState({ subscriptionRenewal: !this.state.subscriptionRenewal })}><OfferMarkIcon /></div>
                                    <div className='text-mini'>автоматически продлевать подписку</div>
                                </div>
                                */}
                            </div>
                        </div>

                        :

                        <div className='sub'>
                            <div className='sub__banner_wrapper'>
                                <div className='sub__banner'>
                                    <div className='sub__banner_content'>
                                        <div className='sub__banner_content_text'>
                                            <div className='banner-title white sub-text'>Полезная подписка, чтобы ничего не пропустить</div>
                                            <div className='banner-text white'>Сохраните доступ к видеозвонкам, архиву записей и прямой трансляции видео</div>

                                        </div>
                                        <img src={adPoster} className='sub__banner_content_image' />
                                    </div>
                                </div>
                            </div>
                            <div className='sub__content_wrapper'>
                                <div className='sub__content'>
                                    <div className='sub__content_nav'>
                                        <div className='sub__content_nav_back button' onClick={() => this.props.history.push(Navigation.GeneralPage)}>
                                            <img src={backIcon}></img>
                                            <div className='value-text--bold'>Назад</div>
                                        </div>
                                    </div>
                                    <div className='sub__content_tariffs_wrapper'>
                                        <div className='sub__content_tariff'>
                                            <div className='sub__content_tariff_header'>
                                                <div className='tariff-text'>Видеосервисы</div>
                                                {yearDiscount &&
                                                    <div className='sub__content_tariff_header_additional'>
                                                        <div className='sub__content_tariff_header_additional_cost'><div className='tariff-text--cost'>{yearDiscount.tarif}</div><div className='tariff-text--currency'>₽</div></div>
                                                        <div className='tariff-text--period'>Год</div>
                                                    </div>
                                                }

                                            </div>
                                            {yearDiscount &&
                                                <div className='sub__content_tariff_expl'>
                                                    <div className='text-norm'><span className='cross-out'>{service.fullTarif} ₽/мес </span>&nbsp; {(Math.floor((yearDiscount.tarif / yearDiscount.monthCount) * 100) / 100)}₽/мес </div>
                                                    <div className='text-norm'>при оплате подписки на год </div>
                                                </div>
                                            }

                                            <div className='sub__content_tariff_conditions'>
                                                <div className='sub__content_tariff_conditions_item'>
                                                    <img src={archive} ></img>
                                                    <div className='sub__content_tariff_conditions_item_info'>
                                                        <div className='sub-title'>Архив событий</div>
                                                        <div className='sub-value'>3 дня</div>
                                                    </div>
                                                </div>
                                                <div className='sub__content_tariff_conditions_item'>
                                                    <img src={fullArchive} ></img>
                                                    <div className='sub__content_tariff_conditions_item_info'>
                                                        <div className='sub-title'>Полный архив видео</div>
                                                        <div className='sub-value'>3 дня</div>
                                                    </div>
                                                </div>
                                                <div className='sub__content_tariff_conditions_item'>
                                                    <img src={key} ></img>
                                                    <div className='sub__content_tariff_conditions_item_info'>
                                                        <div className='sub-title'>Метки движения</div>
                                                        <div className='sub-value'>Доступно</div>
                                                    </div>
                                                </div>
                                                <div className='sub__content_tariff_conditions_item'>
                                                    <img src={quality} ></img>
                                                    <div className='sub__content_tariff_conditions_item_info'>
                                                        <div className='sub-title'>Качество видео</div>
                                                        <div className='sub-value'>Full HD 1080p</div>
                                                    </div>
                                                </div>

                                                <div className='sub__content_tariff_conditions_item'>
                                                    <img src={lenght} ></img>
                                                    <div className='sub__content_tariff_conditions_item_info'>
                                                        <div className='sub-title'>Длина видео для скачивания</div>
                                                        <div className='sub-value'>До 10 минут</div>
                                                    </div>
                                                </div>
                                                <div className='sub__content_tariff_conditions_item'>
                                                    <img src={support} ></img>
                                                    <div className='sub__content_tariff_conditions_item_info'>
                                                        <div className='sub-title'>Видеозвонки</div>
                                                        <div className='sub-value'>Доступно</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='sub__content_tariff_button-wrapper'>
                                                <div className='sub__content_tariff_button button button-text'
                                                    onClick={() => this.setState({ nextIsOpen: true })}>Выбрать тариф</div>
                                            </div>
                                        </div>
                                        <div className='sub__content_tariff base'>
                                            <div className='sub__content_tariff_header'>
                                                <div className='tariff-text'>Базовый</div>
                                                <div className='sub__content_tariff_header_additional'>
                                                    <div className='sub__content_tariff_header_additional_cost'><div className='tariff-text--cost'>0</div><div className='tariff-text--currency'>₽</div></div>
                                                    <div className='tariff-text--period'>Навсегда</div>
                                                </div>
                                            </div>
                                            <div className='sub__content_tariff_conditions'>
                                                <div className='sub__content_tariff_conditions_item'>
                                                    <div className='sub__content_tariff_conditions_item_info'>
                                                        <div className='sub-title'>Архив событий</div>
                                                        <div className='sub-value'>Отсутствует</div>
                                                    </div>
                                                </div>
                                                <div className='sub__content_tariff_conditions_item'>
                                                    <div className='sub__content_tariff_conditions_item_info'>
                                                        <div className='sub-title'>Полный архив видео</div>
                                                        <div className='sub-value'>Отсутствует</div>
                                                    </div>
                                                </div>
                                                <div className='sub__content_tariff_conditions_item'>
                                                    <div className='sub__content_tariff_conditions_item_info'>
                                                        <div className='sub-title'>Метки движения</div>
                                                        <div className='sub-value'>Отсутствует</div>
                                                    </div>
                                                </div>
                                                <div className='sub__content_tariff_conditions_item'>
                                                    <div className='sub__content_tariff_conditions_item_info'>
                                                        <div className='sub-title'>Длина видео для скачивание</div>
                                                        <div className='sub-value'>Отсутствует</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='sub__content_tariff_button-wrapper'>
                                                <div className='sub__content_tariff_button button button-text' onClick={() => this.props.history.push(Navigation.GeneralPage)}>Остаться на базовом</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </> : <Redirect to={"/"} />}
            </>
        );

    }
};

export default connect(
    (state: ApplicationState) => state.AccountState,
    AccountStore.actionCreators
)(SubscriptionPage as any);
